export const iconFontAwesomeUsersPeopleMarsAndVenusBurst = (
	<i className="fa-solid fa-mars-and-venus-burst"></i>
);
